import Yggdrasil from "services/yggdrasil";
import moment from "moment";

const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');

const state = {
    reportingConfiguration: {
        hasCompanies: false,
        hasDepartments: false,
        hasTeams: false,
        maxDate: now,
        minDate: now,
        orderByDefaults: {
            coursesTable: {
                column: "totalWatched",
                direction: "desc"
            },
            membersTable: {
                column: "memberName",
                direction: "asc"
            }
        }
    }
};

const mutations = {
    SET_REPORTING_CONFIGURATION(state, configuration) {
        state.reportingConfiguration = configuration;
    },
    CLEAR_AFTER_LOGOUT(state) {
        state.reportingConfiguration = {};
    }
};

const actions = {
    async loadReportingConfiguration(store) {
        try {
            const reportingConfiguration = await Yggdrasil.loadReportingConfiguration();
            store.commit("SET_REPORTING_CONFIGURATION", reportingConfiguration);
        } catch (error) {
            console.error("Failed to load reporting configuration:", error);
        }
        store.dispatch("ReportsCourses/initializeConfiguration", store.state.reportingConfiguration, { root: true });
        store.dispatch("ReportsUsers/initializeConfiguration", store.state.reportingConfiguration, { root: true });
    },
    async clearAfterLogout(store) {
        store.commit("CLEAR_AFTER_LOGOUT");
    }
};

const getters = {
    getReportingConfiguration: (state) => state.reportingConfiguration
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
